import React from "react";
import SeoHead from "../../components/SeoHead";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import ImageWithTextWithOverlay from "../../components/ImageWithTextWithOverlay";
import NewSubBanner from "../../components/NewSubBanner";
import NewColumnTextWithForm from "@/components/NewColumnTextWithForm";
import LatestAwards from "@/components/LatestAwards";

export default function CommercialServices({ global,   all_awards }) {
  return (
    <>
      <SeoHead
        page_name={`Armed Forces Support/Opportunities | Project engineering and technical recruitment specialists | Carbon60`}
        canonical_link={`diversity`}
      />
      <NewSubBanner
        global={global}
        pathPrefix={`armed-forces.main_banner`}
        customClass={``}
        content={
          <>
            <h1> Ex-Forces and Veterans</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/banner.webp`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        editableContent={false}
        buttonLink3={`#contact-us`}
        buttonTitle3={`Contact Us`}
         breadcrumb_title="Ex-Forces & Veterans"
        secondary_breadcrumb_url={"/job-seekers"}
        secondary_breadcrumb_title={"Job Seekers"}
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`armed-forces_zero.image_with_text_with_overlay`}
        customClass={`py-5`}
        customRow={`d-flex flex-row-reverse`}
        content={
          <>
            <h1> Carbon60: Committed to Supporting Ex-Forces and Veterans</h1>
            <p>
              For many years, Carbon60 have been committed supporters and
              partners of the military and their personnel, including those who
              are currently serving in one of our Armed Forces - who we support
              and celebrate through sponsorship of various events - and
              particularly ex-forces and veterans who have retired from the
              forces and navigating life after service.
            </p>
            <p>
              Understanding that making the transition back into civilian life
              can be a significant challenge and concern for many ex-forces
              personnel, we utilise the experience, expertise and connections of
              our people - including some who are veterans themselves - to not
              only help create new career opportunities for them, but offer the
              advice, support and guidance needed to help kick-start a
              post-service career too.
            </p>
          </>
        }
        imageURL={`/site-assets/images/shutterstock_22065144393.jpg`}
        imageALT={`Job Seekers Featured Image`}
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`armed-forces_one.image_with_text_with_overlay`}
        customClass={`py-5`}
        content={
          <>
            <h2>The Support Carbon60 Provides</h2>
            <p>
              The insights and support that our experienced people provide can
              be invaluable to any ex-forces personnel or veteran who may be
              unsure if and how they can find and start a new career that’s
              suited to them, their skills and experience and their journey back
              into civilian life.
            </p>
            <p>
              Carbon60’s own ex-forces and veterans, many of whom served in the
              military for several years but are now thriving in their new
              careers, strive to help people take the next steps, at the right
              time – not just in their career, but in every day civilian life –
              by sharing experience and knowledge; helping them tailor CV’s and
              better identify and showcase their skills; and point them in the
              right direction, connecting them with employers across a variety
              of sectors.
            </p>
            <p>
              Such advice and guidance are also available on our website,
              through a variety of insightful blogs and guides; whilst we also
              feature employers and companies offering roles and opportunities
              available that would be ideally suited to ex-forces and veterans,
              their skillsets and their experience.
            </p>
          </>
        }
        imageURL={`/site-assets/images/shutterstock_1983983387-min.jpg`}
        imageALT={`Featured Image`}
      />

      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`armed-forces_two.image_with_text_with_overlay`}
        customClass={`py-5`}
        customRow={`d-flex flex-row-reverse`}
        content={
          <>
            <h2>Career Opportunities for Ex-Forces and Veterans</h2>
            <p>
              It isn’t only us who strive to support ex-forces and veterans,
              recognising their skills, discipline and commitment and the
              potential to apply it to a career outside of service – many
              companies Carbon60 are in partnership with do too.
            </p>
            <p>
              That’s why you’ll find that many of our clients, including
              globally-recognised organisations such as STS Aviation, provide
              career opportunities that have been created specifically with
              ex-forces and veterans in mind – ranging from apprenticeships
              offering chances to build-on and develop existing skills and
              qualifications to full-time roles in which people can take on and
              thrive within.
            </p>
          </>
        }
        imageURL={`/site-assets/images/shutterstock_2325807333-min.jpg`}
        imageALT={`Job Seekers Featured Image`}
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`armed-forces_three.image_with_text_with_overlay`}
        customClass={`py-5`}
        content={
          <>
            <h2>Why Connect with Carbon60? </h2>
            <p>
              Carbon60’s long-term support for our brave military service men
              and women, and passion for championing their skills, dedication
              and finding them a secure, rewarding and enjoyable route back into
              civilian life isn’t only proven through our experience and
              expertise.
            </p>
            <p>
              As Forces Covenant civilian employment support providers and one
              of the UK’s Top 25 Veteran Employers, and advocates of STEM
              learning through hands-on experiences and practical education,
              Carbon60 are recognised as a company that ex-forces and veterans
              can trust and depend on as they look to take a vital next step in
              post-service life.
            </p>
            <p>
              So, if you’re a military leaver and need help beginning or
              building a better civilian career journey, we are here for you.
              Get in touch for more information, support and guidance and we’ll
              put you on the right path.
            </p>
          </>
        }
        imageURL={`/site-assets/images/zsn2ba9c3v08f7kh3slxaef1r1co.png`}
        imageALT={`Featured Image`}
      />
      <ImageWithTextWithOverlay
        global={global}
        pathPrefix={`armed-forces_four.image_with_text_with_overlay`}
        customClass={`py-5`}
        customRow={`d-flex flex-row-reverse`}
        content={
          <>
            <h2>Help for you, and your family too</h2>
            <p>
              As part of our ongoing commitment to veterans and ex-forces personnel, we are also dedicated to supporting military families as they also experience the journey from service life to civilian life, which for many can be difficult to navigate and understand. We provide guidance on what support is available for those struggling with their physical or mental health or finding it hard settling back into a civilian way of life and struggling to find work or somewhere to live; can direct people towards specialist care they may need; and even help them to get financial support. Help for you, and your family too.
            </p>
            <p>&nbsp;</p>
            <h2>We’re guided by Military to Civilian Transition Experience & Expertise</h2>
            <p>
              Having experienced the transition from military life to civilian life, and build a long, successful career since leaving the Royal Navy, our very own Ian Drysdale is at the very heart of our drive to help as many veterans and ex-forces personnel as possible kick start a career upon bringing their journey in the services to an end. <a href="https://www.carbon60global.com/blog/our-qanda-with-ex-forces-in-business-award-nominee-ian-drysdale">Find out more about Ian, his experiences, and his knowledge, in our blog</a>.
            </p>
          </>
        }
        imageURL={`/site-assets/images/shutterstock_485076070-min.jpg`}
        imageALT={`Featured Image`}
      />

<LatestAwards
				global={global}
				pathPrefix={`homepage.latest_awards`}
				customClass={`pt-5 text-center`}
				content={
					<>
						<h2>Trusted by Leading Businesses</h2>
					</>
				}
				post={all_awards}
				buttonLink={``}
				buttonTitle={``}
				swiperID={`latestAwardsSwiper`}
			/>

      <NewColumnTextWithForm
        global={global}
        pathPrefix={`armed-forces.service_page.new_column_text_with_form`}
        content={
          <>
            <h2>Drive better workforce performance</h2>
            <p>
              Book a call with us and find out how we can help you and your team
              achieve greater heights.
            </p>
          </>
        }
        formId={`0371b3ee-bf43-4852-95bf-e798c3f9b685`}
        customClass="py-5 "
        locale=""
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  const awards = await Collection('awards_industry_recognition');
  const all_awards = awards.orderBy('order').getItems().filter(i => i.show_on.includes('Home'));


  return {
    props: {
      global,
      all_awards,
    },
  };
}
